import React, { useContext } from 'react';
import { ModalContext } from '../../../contexts/modalContext';
import { LogInContext } from '../../../contexts/logInContext';
import { ModalWrapper, RemoveModalWrapper } from '../../Modals/Modals.styles';
import { ModalCreateButtons } from '../../Modals/ModalButtons'
import { SkillToggleStatus } from '../../../api';
import { LessonsContext } from '../../../contexts/lessonsContext';

const ApproveSkillModal = ({ modalRef, closeModal }) => {
  const { selectedMaterial } = useContext(LessonsContext);
  const { showModal, setShowModal } = useContext(ModalContext);
  const { token } = useContext(LogInContext);

  const handleApproveStudent = async () => {
    const res = await SkillToggleStatus(selectedMaterial?.id, token);

    if (res.status === 'success') {
        setShowModal(false);
    }
  };

  return (
    <>
      {showModal && (
        <ModalWrapper ref={modalRef} onClick={closeModal}>
          <RemoveModalWrapper>
            <h3>Are you sure you want to approve {selectedMaterial?.name}? </h3>
            <ModalCreateButtons
              text="Save Changes"
              onClick={handleApproveStudent}
            />
          </RemoveModalWrapper>
        </ModalWrapper>
      )}
    </>
  );
};

export default ApproveSkillModal;
